import { __assign, __spreadArray } from "tslib";
import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import noop from '../utils/noop';
import IconButton from '@wix/da-ds/pkg/Buttons/IconButton';
import CloseBigIcon from '@wix/da-ds/pkg/Icons/CloseBig';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import { ResourceType } from '../types/resource';
import UserSampleGallery from './UserSampleGallery';
import s from './WatchSuggestionList.scss';
export var WatchSuggestionList = function (_a) {
    var watchSuggestions = _a.watchSuggestions, numSuggestionsShown = _a.numSuggestionsShown, currentUserId = _a.currentUserId, duperbrowseContextTitle = _a.duperbrowseContextTitle, className = _a.className, allowUnsuggest = _a.allowUnsuggest, _b = _a.unsuggestUser, unsuggestUser = _b === void 0 ? noop : _b, _c = _a.onWatch, onWatch = _c === void 0 ? noop : _c;
    var t = useTranslation().t;
    var _d = useState([]), hiddenUserIds = _d[0], setHiddenUserIds = _d[1];
    var removeAndUnsuggestUser = useCallback(function (userId) {
        unsuggestUser(userId);
        setHiddenUserIds(__spreadArray(__spreadArray([], hiddenUserIds, true), [userId], false));
    }, [hiddenUserIds, setHiddenUserIds, unsuggestUser]);
    var toBeRendered = watchSuggestions
        .map(function (suggestion, i) { return (__assign(__assign({}, suggestion), { rank: i })); })
        .filter(function (_a) {
        var user = _a.user;
        return hiddenUserIds.indexOf(user.userId) < 0;
    })
        .slice(0, numSuggestionsShown);
    return (React.createElement("ul", { className: className }, toBeRendered.length ? (toBeRendered.map(function (_a) {
        var user = _a.user, deviations = _a.deviations, rank = _a.rank;
        return (React.createElement("li", { key: user.useridUuid, className: s['list-item'] },
            React.createElement(BiLoggerContextProvider, { value: { rank: rank } },
                React.createElement(UserSampleGallery, { className: s['user-sample-gallery'], user: user, deviations: deviations, 
                    // this... shouldn't happen...
                    isOwnUser: user.userId === currentUserId, duperbrowseContextTitle: duperbrowseContextTitle, onWatch: onWatch }),
                allowUnsuggest && (React.createElement(IconButton, { className: s['unsuggest-button'], size: "small", icon: CloseBigIcon, onClick: function () { return removeAndUnsuggestUser(user.userId); }, "aria-label": t('watchSuggestionsV2.a11y.unsuggest'), biData: {
                        evid: BiEventType.WATCH_SUGGESTION_REMOVE_CLICK,
                        sectionname: 'watch_suggestions',
                        typeid: ResourceType.USER,
                        itemid: user.userId,
                        items_selected_count: 1,
                    } })))));
    })) : (React.createElement("p", { className: s['empty'] }, t('watchSuggestionsV2.empty')))));
};
WatchSuggestionList.displayName = 'WatchSuggestionList';
export default WatchSuggestionList;
//# sourceMappingURL=WatchSuggestionList.js.map